// Escape newlines in a string, so they can be displayed as \n or \r in the UI
export const stringEscapeNewlines = (str?: string | null): string =>
    !str ? '' : str.replace(/\n/g, '\\n').replace(/\r/g, '\\r')
